
import axiosInstance from '../axiosInstance';
import { useEffect, useMemo, useState, useRef } from 'react';
import { FaSearch } from 'react-icons/fa';

import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL_All } from '../api';
import * as general from '../libs/general';
import { fetchReconcileVatCustomerPermissions } from "../libs/customerCreatePermission";
import Paging from '../components/Paging';
import CheckingReview from '../components/orders/CheckingReview';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';

function InvoiceManagement() {
  const [pageData, setPageData] = useState({ content: [] });
  const [pageOrderData, setPageOrderData] = useState({ content: [] });
  const [errorMessage, setErrorMessage] = useState("");

  const [checkingReviewData, setCheckingReviewData] = useState(null);

  const [selectedOrders, setSelectedOrders] = useState([]);

  const hasRun = useRef(false);

  const [customerVats, setCustomerVats] = useState("");
  const [params, setParams] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [reconcilePerm, setReconcilePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
    canDelete: false,
  });

  useEffect(() => {
    searchOrders();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchReconcileVatCustomerPermissions(axiosInstance);
      if (!cancelled) {
        setReconcilePerm({
          loaded: true,
          canView: Boolean(p?.canView),
          canCreate: Boolean(p?.canCreate),
          canEdit: Boolean(p?.canEdit),
          canDelete: Boolean(p?.canDelete),
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleRefreshPage = (e) => {
    searchOrders();
  };


  const handleSearchCustomerChange = (e) => {
    var searchValue = e.target.value;

    var name = e.target.name;
    var newParams = { ...params };
    newParams[name] = e.target.value;
    setParams(newParams);

    var thTag = e.target.closest('.th-col');
    if (thTag) {
      var selectedTag = thTag.querySelector('.item_selected');
      if ((selectedTag && selectedTag.innerText === searchValue) || searchValue === '') {
        if (name === 'customerCode') {
          searchOrders({ page: 0, customerCode: searchValue, taxVat: '' });
        } else {
          searchOrders({ page: 0});
        }
      }
    }


  };

  const searchOrders = async (filter) => {
    if (window.calling) return;
    window.calling = true;

    setIsLoading(true);
    setErrorMessage('');

    var checkAllTag = document.querySelector('.check_all');
    if (checkAllTag) {
      checkAllTag.removeAttribute('data-unchecked');
      checkAllTag.checked = false;
    }
    setSelectedOrders([]);

    var params = general.getSession('form_order_filter');

    var formData = general.getFormData('#form_order_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('form_order_filter');
      Object.assign(params, oldParams);
      //setSearchQuery(params.keyword);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('form_order_filter', params);
    setParams(params);
    window.initializeFilterValue(params);


    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get('/api/import-orders/searchdetails', { params: filteredParams });
      setPageOrderData(response.data);
      var processedOrders = response.data.page.content;
      //debugger;
      if (params.status) {
        var statusNames = params.status.split(';');
        var listStatus = response.data.orderStatus;
        listStatus.forEach(obj => {
          if (statusNames.includes(obj.name)) {
            obj.active = true;
          }
        });
      }
      if (!params.taxVat) {
        var listVats = response.data.listTexts.join(',');
        setCustomerVats(listVats);
      }

      var checkAllTag = document.querySelector('.check_all');
      if (checkAllTag) {
        checkAllTag.removeAttribute('data-listIds');
        if (response.data.listIds) {
          checkAllTag.setAttribute('data-listIds', response.data.listIds.join(","));
        }
        var uncheckedList = checkAllTag.getAttribute('data-unchecked');
        if (uncheckedList || checkAllTag.checked) {
          if (!uncheckedList) uncheckedList = '';
          var uncheckedItems = uncheckedList.split(',').map(item => parseInt(item.trim())).filter(Number.isInteger);
          setSelectedOrders(processedOrders.filter(order => !uncheckedItems.includes(order.id)).map(order => order.id));
        }
      }
    } catch (error) {
      setPageData({ content: [] });
      setErrorMessage(error.message);
      console.error(error);
    } finally {
      window.calling = false;
    }

    setIsLoading(false);
  };

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchOrders({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchOrders({ page: page - 1 });
  };


  const prepareChecking = async (params) => {
    if (!reconcilePerm.loaded || !reconcilePerm.canCreate) {
      toast.warning("Bạn không có quyền tạo đối soát.");
      return;
    }
    var listIds = selectedOrders;
    if (listIds.length === 0) {
      toast.error('Phải chọn ít nhất một mục.');
      return;
    }
    var params = { listIds: selectedOrders };
    var isValid = await validateInvoice(params);
    if (isValid) setCheckingReviewData(params);
  };

  const validateInvoice = async (params) => {
    const textIds = params.listIds.join(';');
    try {
      var urlApi = `/api/invoices/getInvoiceReview?codes=${textIds}`;
      const response = await axiosInstance.get(urlApi);
      var obj = response.data;
      if (obj.success === false) {
        toast.error(obj.message);
        return false;
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
      return false;
    }
    return true;
  }

  function removeItem(array, value) {
    return array.filter(item => item !== value);
  }
  const handleSelectOrder = (id) => {
    setSelectedOrders((prevSelected) => {
      const updated = prevSelected.includes(id)
        ? prevSelected.filter((orderId) => orderId !== id)
        : [...prevSelected, id];

      var totalNumberPages = pageOrderData.page.totalPages;
      var checkallTag = document.querySelector('.check_all');
      if (totalNumberPages === 1 && pageOrderData.listIds) {
        const allChecked = pageOrderData.listIds.every(orderId => updated.includes(orderId));
        if (checkallTag) checkallTag.checked = allChecked;
      }
      var isChecked = updated.includes(id);
      var uncheckedList = checkallTag.getAttribute('data-unchecked');
      var idText = id + '';
      if (totalNumberPages > 1 && (checkallTag.checked || uncheckedList)) {
        if (!uncheckedList) uncheckedList = '';
        var uncheckedItems = uncheckedList.split(',').filter(str => str !== "");
        if (isChecked) {
          uncheckedItems = removeItem(uncheckedItems, idText);
        } else {
          var isExisted = uncheckedItems.includes(idText);
          if (!isExisted) uncheckedItems.push(idText);
        }
        var textUncheckedItems = uncheckedItems.join(',');

        if (textUncheckedItems) {
          checkallTag.setAttribute('data-unchecked', textUncheckedItems);
          checkallTag.checked = false;
        } else {

          checkallTag.removeAttribute('data-unchecked');
          checkallTag.checked = true;
        }
      }

      return updated;
    }
    );
  };
  const handleSelectAll = () => {
    var checkAllTag = document.querySelector('.check_all');
    checkAllTag.removeAttribute('data-unchecked');
    var isChecked = checkAllTag.checked;
    if (!isChecked) {
      // Nếu tất cả đơn hàng đã được chọn, bỏ chọn tất cả
      setSelectedOrders([]);
    } else {
      // Nếu chưa chọn hết, chọn tất cả đơn hàng
      setSelectedOrders(pageOrderData.listIds);
    }
  };

  return (
    <div>
      <AdLayout>
        <div className="table-responsive web-table">
          <div className="tab-container">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button className="nav-link active">Đơn hàng VAT đã giao</button>
                <button className="nav-link"><Link to="/danh-sach-doi-soat">Danh sách VAT đối soát</Link></button>
              </div>
            </nav>
            <div className="tab-content bg-white" id="nav-tabContent">
              <div className="tab-pane fade show active" id="pane-01" role="tabpanel" aria-labelledby="nav-home-tab">

                <div className="container-fluid pt-2">
                  <div className="text-start mb-2 normal-form">
                      <div className="row">
                      <div className="col-md-5">
                        <form id="form_order_filter">
                          <div className="row">
                            <div className="col-md-7 height-46">
                              <div className="row">
                                <label className="form-label col-form-label col-md-4 text-end">Mã KH</label>
                                <div className="col-md-8">
                                  <div className="th th-col filter-editor">
                                    <span className="filter-ib" data-source-url={API_URL_All + '/api/users/searchUserCodes'} >
                                      <input type="text" name="customerCode" placeholder="Nhập mã khách hàng..." autoComplete="off" onChange={(e) => handleSearchCustomerChange(e)} />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-5">
                              <div className="row">
                                <label className="form-label col-form-label col-md-4 text-end">VAT</label>
                                <div className="col-md-8">
                                  <div className="th th-col filter-editor">
                                    <span className="filter-ib" data-source-key="list_vats">
                                      <input type="text" name="taxVat" placeholder="Nhập vat" autoComplete="off" value={params.taxVat} onChange={(e) => handleSearchCustomerChange(e)} />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <button onClick={(event) => searchOrders({ page: 0 })} className="btn btn-light btn-sm d-none" type="button" title="Tìm kiếm...">
                            <FaSearch />
                          </button>
                        </form>
                      </div>
                      <div className="col-4 col-md-1 p-0">

                        <div>
                          {reconcilePerm.loaded && reconcilePerm.canCreate && (
                            <button onClick={(e) => prepareChecking(e)} type="button" className="btn btn-info btn-sm me-2 " >
                              Tạo đối soát
                            </button>
                          )}
                        </div>
                      </div>

                      </div>

                  </div>
                </div>
                <section className="p-1 ">
                  <DataTable maxHeight="calc(100vh - 220px)" className="table-normal" data-loading={isLoading}>
                    <table className="table table-striped border-normal table-bordered">
                      <thead className="table-primary">
                        <tr>
                          <th className='sticky' width="21px">
                            <input type="checkbox" title='Check all' className='check_all' onChange={() => handleSelectAll()} />
                          </th>

                          <th className="text-center"><span>Ngày</span></th>
                          <th className="text-center">Mã vận đơn TQ</th>
                          <th className="text-center"><span>Mã SP</span></th>
                          <th>Tên sản phẩm</th>

                          <th className="text-center">Số lượng</th>
                          <th className="text-center"><span data-note="vnđ">Giá khai</span></th>
                          <th className="text-center"><span data-note="vnđ">Thành tiền</span></th>
                          <th className="text-center" colspan="2"><span data-note="vnđ">Thuế NK</span></th>

                          <th className="text-center"><span data-note="vnđ">Phí đ.mục</span></th>
                          <th className="text-center"><span data-note="vnđ">Phí ủy.thác</span></th>
                          <th className="text-center"><span data-note="">KG</span></th>
                          <th className="text-center"><span data-note="">M3</span></th>
                          <th className="text-center"><span data-note="">Cước phí</span></th>

                          <th className="text-center"><span data-note="">Phụ phí</span></th>
                          <th className="text-center"><span data-note="">B.hiểm</span></th>
                          <th className="text-center"><span data-note="vnđ">Tổng trước VAT</span></th>
                          <th className="text-center"><span data-note="%">VAT</span></th>

                          <th>Ghi chú</th>
                          <th className="text-center">Mã KH</th>
                          <th>Email KH</th>
                        </tr>
                      </thead>
                      {pageOrderData.page && pageOrderData.page.content && pageOrderData.page.content.map((item, index) => (
                        <tbody className="tbody-row">
                          <tr key={index}>
                            <td className='sticky' title={item.id}>
                              <input
                                type="checkbox"
                                checked={selectedOrders.includes(item.id)}
                                onChange={() => handleSelectOrder(item.id)}
                              />
                            </td>

                            <td className="text-success text-center" title={general.formatTimeShort(item.orderDate)}>{general.formatDate(item.orderDate)}</td>
                            <td className="text-success text-center">{item.cnCode}</td>
                            <td className='text-success text-center' title={`orderId: ${item.orderId}`}>{item.productCode}</td>
                            <td className="text-success text-start">{item.productName}</td>

                            <td className="text-success text-center">{item.quantity}</td>
                            <td className="text-success text-center">{general.formatNumber(item.priceDeclare)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.priceDeclare * item.quantity)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.taxImport)}%</td>
                            <td className="text-success text-center">{general.formatNumber(Math.round(item.priceDeclare * item.quantity * item.taxImport / 100))}</td>

                            <td className="text-success text-center">{general.formatNumber(item.feeItem)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.feeEntrust)}</td>
                            <td className="text-success text-center">{general.formatDecimal(item.weight)}</td>
                            <td className="text-success text-center">{general.formatDecimal(item.size)}</td>
                            <td title={`FeeWeight: ${general.formatNumber(item.feeWeight)} - FeeSize: ${general.formatNumber(item.feeSize)}` } className="text-success text-center">{general.formatNumber(Math.max(item.feeWeight, item.feeSize))}</td>

                            <td className="text-success text-center">{general.formatNumber(item.feeSurcharge)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.priceInsurance)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.fee + (item.priceDeclare * item.quantity) * (100 + item.taxImport)/100)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.taxVat)}</td>

                            <td className="text-start text-truncate mw-101" title={general.mergeText(item.noteAdmin, item.noteUser)}>{general.mergeText(item.noteAdmin, item.noteUser)}</td>
                            <td className="text-center">{item.customerCode}</td>
                            <td className="text-start">{item.customerEmail}</td>
                          </tr>
                        </tbody>
                      ))}


                      <tbody>
                        {errorMessage === '' && pageOrderData.page && pageOrderData.page.content.length === 0 && (
                          <tr>
                            <td colSpan="21" className="text-center">Không tìm thấy dữ liệu</td>
                          </tr>
                        )}
                        {errorMessage !== '' && (
                          <tr>
                            <td colSpan="21" className="text-center">{errorMessage}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </DataTable>
                </section>
              </div>

            </div>


          </div>

          <div className="my-1 d-flex justify-content-end align-items-center">
              <Paging
                pageData={pageOrderData}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleChangeItemsPerPage}
              />
          </div>


          <input type="hidden" id="list_vats" value={customerVats} />

          {checkingReviewData && (
            <CheckingReview
              data={checkingReviewData}
              handleSearch={handleRefreshPage}
              canEdit={reconcilePerm.canEdit}
              canDelete={reconcilePerm.canDelete}
            />
          )}

        </div >
      </AdLayout>

  </div>
  );
}
export default InvoiceManagement;